import { IressSkeleton } from '@iress-oss/ids-components';
import './WidgetSkeleton.css';

/**
 * Skeleton shown while the chat widget is first mounting.
 * Mirrors the layout seen in the "Launching Xplan Porter" screenshot:
 *   - a short line
 *   - two long lines
 *   - a medium line
 *   - two rows of (circle + full-width line) for suggested-action items
 */
export function WidgetSkeleton() {
  return (
    <div className="porter-widget-skeleton" aria-label="Loading" role="status">
      <IressSkeleton width="49%" height="16px" mode='rect'/>
      <IressSkeleton width="100%" height="16px" mode='rect' />
      <IressSkeleton width="100%" height="16px" mode='rect' />
      <IressSkeleton width="80%" height="16px" mode='rect' />

      <div className="porter-widget-skeleton__row">
        <IressSkeleton width="24px" height="24px" mode='circle' />
        <IressSkeleton width="100%" height="16px" mode='rect' />
      </div>
      <div className="porter-widget-skeleton__row">
        <IressSkeleton width="24px" height="24px" mode='circle' />
        <IressSkeleton width="100%" height="16px" mode='rect' />
      </div>
    </div>
  );
}
